import { Query } from '@varo/graphql-schema-types';
import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import FetchSavingsAPY from 'services/graphql/queries/FetchSavingsAPY';
import Button from 'shared/components/vxl/Button/Button';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';
import { useQuery } from 'urql';

const FundSavingsAccount = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('accounts', {
    keyPrefix: 'openSavings',
  });

  const [savingsAPYResult] = useQuery<Query>({
    query: FetchSavingsAPY,
    requestPolicy: 'cache-and-network',
  });
  const { data: savingsAPYData, fetching: savingAPYFetching } =
    savingsAPYResult;
  const savingsAPYValue = savingsAPYData?.lookup?.savingsApy || '';

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ScreenTransitionOverlay
        isLoading={savingAPYFetching}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={null}
      />
      <View style={styles.skipForNowSection}>
        <View>
          <Button
            label={translatedText('skipForNow')}
            type="TEXT"
            onPress={() => {
              navigateBack();
            }}
            analyticsId="skipNow"
          />
        </View>
      </View>
      <ActionScreen
        titleText={translatedText('fundYourSavingAccountTitle')}
        primaryButton={{
          label: translatedText('transferFundButton'),
          onPress: () => {
            router.replace({
              pathname: '/move-money/transfer/transfer-money',
              params: {
                typeOfAccount: 'Saving',
              },
            });
          },
          analyticsId: 'transferFund',
        }}
        bodyContent={
          <BodyBaseText numberOfLines={3}>
            {translatedText('fundYourSavingContent', {
              savingsAPY: savingsAPYValue ? ` ${savingsAPYValue}` : '',
            })}
          </BodyBaseText>
        }
        titleTextStyle="extra-large"
        visual="MONEYBAG_A"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  skipForNowSection: {
    alignItems: 'flex-end',
    marginHorizontal: theme.spacing.m,
    marginTop: theme.spacing.xxl,
  },
});

export default FundSavingsAccount;
